import { Box } from "@mui/material";
import Popover from '@mui/material/Popover';
import React from 'react';
import { makeStyles } from "tss-react/mui";
import TileViewButton from "../../../video-layout/components/TileViewButton";
import HideScreen from "./components/HideScreen";
import ScaleScreen from "./components/ScaleScreen";
import ViewController from "./components/ViewController";
import './LayoutButton.css';
const useStyles = makeStyles()(theme => {
    return {
        backgroundColorPopover: {
            backgroundColor: theme.palette.backgroundColorPopover,
        },
        popover: {
            backgroundColor: theme.palette.backgroundColorPopover,
            padding: '1rem',
            width: '292px',
        },
        textItem: {
            color: theme.palette.text01,
            marginLeft: '10px',
            fontSize: '14px'
        },
        itemPopover: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start',
            padding: '4px 12px 4px 6px',
            margin: '8px 0px',
            '&:hover': {
                backgroundColor: theme.palette.default00,
                cursor: 'pointer',
                borderRadius: '6px'
            },
            '& .icon-item-layout': {
                marginRight: '52px'
            },
            '& .icon-item-layout svg path': {
                stroke: 'none',
                fill: '#ffff'
            }
        },
        itemPopoverViewController: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '4px 12px 4px 6px',
            margin: '8px 0px',
            '&:hover': {
                backgroundColor: theme.palette.default00,
                cursor: 'pointer',
                borderRadius: '6px'
            },
            '& .icon-item-layout': {
                marginRight: '52px'
            },
            '& .icon-item-layout svg path': {
                stroke: 'none',
                fill: '#ffff'
            }
        },
        choosen: {
            borderRadius: '6px',
        },
        borderTop: {
            borderTop: '1px solid #44494D',
        }
    };
});
const LayoutButton = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const { classes, cx } = useStyles();
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    return (React.createElement("div", { className: "layout-button" },
        React.createElement(TileViewButton, { buttonKey: "tileview", key: "tileview", showLabel: true, customClass: 'item-toolbox-custom', isShowTooltip: false, isBeta: false, isOnClick: true, onClick: handleClick }),
        React.createElement(Popover, { id: "layout-popover", open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, sx: {
                borderRadius: '10px',
                backgroundColor: 'transparent'
            } },
            React.createElement(Box, { className: classes.popover },
                React.createElement(ViewController, { classes: classes, cx: cx, handleClose: handleClose }),
                React.createElement(HideScreen, { classes: classes, cx: cx, handleClose: handleClose }),
                React.createElement(ScaleScreen, { classes: classes, cx: cx, handleClose: handleClose })))));
};
export default LayoutButton;
